@use '../../../shared-styles' as *;
@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .rect { @include rect; }
  .rectProfit { fill: var(--viz-bullish); }
  .circle { @include circle; }
  .animatedGroup { @include animated-group; }

  .value {
    @include typography-v2-body-xs;
    fill: var(--viz-bearish);
    text-anchor: middle;
  }

  .valueProfit {
    fill: var(--viz-bullish);
  }

  .medianValue {
    @include typography-v2-body-xs;
    fill: var(--text-default);
    text-anchor: middle;
  }

  .styledTextWithBg {
    text {
      @include typography-v2-body-xs;
      fill: var(--viz-bearish);
    }
  }

  .styledTextWithBgProfit {
    text {
      fill: var(--viz-bullish);
    }
  }
}
